import React from 'react';
import {
  AppShell,
  Burger,
  Button,
  Container,
  Group,
  Text,
  Box,
  Drawer,
  Stack,
  Anchor,
} from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconMessage, IconSettings } from '@tabler/icons-react';

export default function Header() {
  const [opened, { toggle, close }] = useDisclosure(false);

  return (
    <>
      <AppShell.Header 
        style={{ 
          backgroundColor: 'rgba(255, 255, 255, 0.95)', 
          backdropFilter: 'blur(10px)',
          borderBottom: '1px solid #e9ecef'
        }}
      >
        <Container size="xl" h="100%">
          <Group justify="space-between" h="100%">
            {/* Logo */}
            <Group gap="md">
              <Box
                style={{
                  width: 40,
                  height: 40,
                  background: 'linear-gradient(135deg, #2563eb 0%, #06b6d4 100%)',
                  borderRadius: 12,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'relative',
                  boxShadow: '0 4px 12px rgba(37, 99, 235, 0.3)'
                }}
              >
                <IconSettings size={24} color="white" />
                <Box
                  style={{
                    position: 'absolute',
                    top: -2,
                    right: -2,
                    width: 16,
                    height: 16,
                    background: 'linear-gradient(135deg, #06b6d4 0%, #2563eb 100%)',
                    borderRadius: '50%',
                    animation: 'pulse 2s infinite'
                  }}
                />
              </Box>
              <Box>
                <Text
                  size="xl"
                  fw={700}
                  style={{
                    background: 'linear-gradient(135deg, #2563eb, #06b6d4)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text'
                  }}
                >
                  KitChain AI
                </Text>
                <Text size="xs" c="dimmed" mt={-2}>
                  Order Automation for Manufacturing
                </Text>
              </Box>
            </Group>

            {/* Desktop Navigation */}
            <Group gap="xl" visibleFrom="md">
              {NAV_ITEMS.map((item) => (
                <Anchor
                  key={item.href}
                  href={item.href}
                  c="dark.6"
                  fw={500}
                  td="none"
                  style={{
                    transition: 'color 0.2s ease',
                    '&:hover': {
                      color: '#2563eb'
                    }
                  }}
                >
                  {item.label}
                </Anchor>
              ))}
              
              <Button 
                size="sm"
                leftSection={<IconMessage size={16} />}
                style={{
                  background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
                  border: 'none'
                }}
                component="a"
                href="#contact"
              >
                Book Discovery Call
              </Button>
            </Group>

            {/* Mobile Menu Button */}
            <Burger
              opened={opened}
              onClick={toggle}
              hiddenFrom="md"
              size="sm"
            />
          </Group>
        </Container>
      </AppShell.Header>

      {/* Mobile Drawer */}
      <Drawer
        opened={opened}
        onClose={close}
        title="Navigation"
        padding="md"
        size="sm"
        position="right"
      >
        <Stack gap="lg">
          {NAV_ITEMS.map((item) => (
            <Anchor
              key={item.href}
              href={item.href}
              c="dark.6"
              fw={500}
              td="none"
              onClick={close}
              style={{ fontSize: 16 }}
            >
              {item.label}
            </Anchor>
          ))}
          
          <Button 
            leftSection={<IconMessage size={16} />}
            style={{
              background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
              border: 'none'
            }}
            fullWidth
            component="a"
            href="#contact"
            mt="xl"
          >
            Book Discovery Call
          </Button>
        </Stack>
      </Drawer>

      <style jsx>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
      `}</style>
    </>
  );
}

const NAV_ITEMS = [
  {
    label: 'How It Works',
    href: '#how-it-works',
  },
  {
    label: 'Results',
    href: '#results',
  },
  {
    label: 'FAQ',
    href: '#faq',
  },
  {
    label: 'Contact',
    href: '#contact',
  },
]; 